export class LockObject {
  Edit_Status?: LockObjectEditStatusType;
  Object_ID: string;
  Object_Code: LockObjectCodeType;
  Lock_Sub_Type: LockSubType;
}

export class UserDefinedValidation {
  Name: string;
  Severity: string;
  Message: string;
}

export enum LockObjectCodeType {
  Contract = 'Contract',
  Reconcile = 'Reconcile',
  Deposit = 'Deposit',
  Disburse = 'Disburse',
  JournalEntry = 'JrnlEntry',
  BalanceForward = 'BalForward',
  Receipt = 'Receipt',
  Invoice = 'Invoice',
  Installment = 'Installmnt',
  BankRec = 'BankRec',
  PeriodEnd = 'PeriodEnd',
  OffsetDef = 'OffsetDef',
  LiabCert = 'Cert',
  VendorBill = 'Bill',
  ThirteenthPeriod = '13thPeriod',
  IntegrationService = 'Service',
  GLAccount = 'GLAcct',
  Lockbox = 'Lockbox'
}

export enum LockSubType {
  Contract = 'Contract',
  Reconcile = 'Reconcile',
  Deposit = 'Deposit',
  JournalEntry = 'JrnlEntry',
  BalanceForward = 'BalForward',
  Disburse = 'Disburse',
  Receipt = 'Receipt',
  Invoice = 'Invoice',
  Installment = 'Installmnt',
  BankRec = 'BankRec',
  PeriodEnd = 'PeriodEnd',
  OffsetDef = 'OffsetDef',
  LiabCert = 'Cert',
  VendorBill = 'Bill',
  ThirteenthPeriod = '13thPeriod',
  IntegrationService = 'Service',
  CheckPrint = 'ChkPrint',
  Lockbox = 'Lockbox',
  GLAccount = 'GLAcct'
}

export enum LockObjectEditStatusType {
  Add = 'A',
  Delete = 'D',
  NoChange = 'N'
}

export enum LockEventType {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete'
}
